import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogTransition from '../DialogTransition';
import PrimaryDialogButton from '../PrimaryDialogButton';
import SecondaryDialogButton from '../SecondaryDialogButton';
import styles from './styles';

function PromptDialog(props) {

    let {
        classes,
        disabled,
        cancelClicked,
        confirmClicked,
        confirmText,
        handleClose,
        cancelText,
        open,
        title,
        message
    } = props;

    disabled = Boolean(disabled);

    return (
        <Dialog
            className={classes.dialogRoot}
            open={open || false}
            onClose={handleClose}
            TransitionComponent={DialogTransition}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">

            <DialogTitle id="alert-dialog-title">
                {title || ''}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description" className={classes.message}>
                    {message || ''}
                </DialogContentText>
            </DialogContent>

            <DialogActions className={classes.actionRoot}>
                {props.showCancel &&
                    <SecondaryDialogButton onClick={cancelClicked} disabled={disabled}>
                        {cancelText || 'No'}
                    </SecondaryDialogButton>
                }
                <PrimaryDialogButton onClick={confirmClicked} autoFocus disabled={disabled}>
                    {confirmText || 'Yes'}
                </PrimaryDialogButton>
            </DialogActions>

        </Dialog>
    );
}

PromptDialog.propTypes = {
    disabled: PropTypes.bool,
    cancelClicked: PropTypes.func,
    confirmClicked: PropTypes.func.isRequired,
    confirmText: PropTypes.string,
    handleClose: PropTypes.func,
    cancelText: PropTypes.string,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string
};

export default withStyles(PromptDialog, styles);